const getDiscountRuleSaveResult = () => {
    return DiscountRuleSaveResult;
}

const getSaveDiscountRuleDetailsResult = () => {
    return SaveDiscountRuleDetailsResult;
}

const getAssignDiscountRuleResult = () => {
    return AssignDiscountRuleResult;
}

const getAddDiscountResultEnum = () => {
    return AddDiscountResultEnum;
}

const getAddItemsOfServiceEnum = () => {
    return SaveItemsOfServiceResult;
}

const UploadExcel = {
    Success: 1,
    Failure: 2,
    WrongFile: 3,
    EmptyExcel: 4,
    NotSameFile: 5,
    NeedToReview: 6,
    ExceedMaxLength: 7,

}
const getUploadExcelEnums = () => {
    return UploadExcel;
}
const DiscountRuleSaveResult = {
    Success: 1,
    Failure: 2,
    AlreadyExists: 3,
    Concurrency: 4
}

const SaveDiscountRuleDetailsResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    AlreadyExistDiscountRuleDetails: 4
}

const AssignDiscountRuleResult = {
    Success: 1,
    Faild: 2,
    AlreadyAssigned: 3,
    Concurrency: 4
}

const WaseleResult = {
    Success: 1,
    Failure: 2,
    RowAlreadyExists: 3,
    ContractCallFailed: 4,
    Concurrency: 5,
    MissingRow: 6
}
const getWaseleResult = () => {
    return WaseleResult;
}

const AddDiscountResultEnum = {
    SavedSuccess: 1,
    FailedToSave: 2,
    Concurrency: 3,
    NotAllowedToEditDiscount: 4,
    ServiceNotePriced: 5,
    CannotEditClaimed: 6,
    NotAllowedToGiveDiscount: 7,
    DiscountPercentageGreaterThanAllowedLimit: 8,
    CannotEditValidatedService: 9,
    CannotEditClaimedValidatedService: 10
}

const ProductClassificationEnum = {
    Medication: 1,
    MedicalConsumable: 2,
    MedicalService: 3,
    Procedure: 4,
    LABService: 5,
    RADService: 6,
    Other: 7,
    Operations: 9,
    BloodProducts: 10
}

const SaveItemsOfServiceResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
}


const PopupType = {
    Success: 1,
    Error: 2,
    Warning: 3,
}
const getPopupTypeEnums = () => {
    return PopupType;
}

const ApprovalStatusEnum = {
    Posted: 1,
    Sent: 2,
    Hold: 3,
    Approved: 4,
    Rejected: 5,
    UnApproved: 6,
    PartiallyApproved: 8
}
const getApprovalStatusEnum = () => {
    return ApprovalStatusEnum;
}
const ServiceTypeEnum = {
    Admission : 1,
    Package : 2,
    PlannedPackage : 3,
    PlannedOrder : 4

}
const getServiceTypeEnum = () => {
    return ServiceTypeEnum;
}
const ActionStatusEnum = {
    UndoApprove: 1,
    Reject: 2
}
const getActionStatusEnum = () => {
    return ActionStatusEnum;
}

const EligibilityRequestPurpose = {
    AuthRequirements: 0,
    Benefits: 1,
    Discovery: 2,
    Validation: 3
}
const getEligibilityRequestPurpose = () => {
    return EligibilityRequestPurpose;
}
const getProductClassification = () => ProductClassificationEnum;

const CheckEligibilityResult = {
    Success: 1,
    Failed: 2,
    ResponseParsingFailure: 3
}
const getCheckEligibilityResult = () => CheckEligibilityResult;

const GetInsuranceInfoResult = {
    Success: 1,
    Failed: 2,
    HIDPAPIFailure: 3
}

const getGetInsuranceInfoResult = () => GetInsuranceInfoResult;

const ReloadStatementResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
}

const getReloadStatementResult = () => ReloadStatementResult;


const VisitClaimNphiesStatus = {
    QueuedInHIC: 1,
    Invalid: 2,
    QueuedInNPIES: 3,
    ErrorInResponse: 4,
    Approved: 5,
    Rejected: 6,
    PartiallyApproved: 7,
    Cancelled: 8,
    PaymentReconciled: 9,
    PayNoticeSent: 10,
    Validated: 11,
    New: 12
}

const getVisitClaimNphiesStatus = () => VisitClaimNphiesStatus;

const CancelRequestEnums = {
    SingleCancelRequest: 1,
    BulkCancelRequest: 2,
}

const getCancelRequestEnums = () => CancelRequestEnums;

const SendStatementsToNphiesResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    InvalidStatementByConfiguration: 4,
    HasInProgressRecords: 5,
    FlagIsEmpty: 6
}

const getSendStatementsToNphiesResult = () => SendStatementsToNphiesResult;

const MarkStatementToCancelResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    HasInProgressRecords: 4,
}

const getMarkStatementToCancelResult = () => MarkStatementToCancelResult;

const SendClaimResultEnum = {
    Sent: 1,
    Pended: 2,
    InternalError: 3,
    ItemPriceError: 4,
    InvalidFileExtention: 5,
    VmError: 6,
    Concurrency: 7
}
const getSendClaimResultEnum = () => SendClaimResultEnum;




const VisitClassificationEnum = {
    Outpatient: 1,
    Inpatient: 2,
    Ambulatory: 3,
    ER: 4
}
const getVisitClassificationEnum = () => VisitClassificationEnum;


const ChangeStatusResultEnum = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    VisitDisharged: 4,
    VisitCashed: 5,
    ExtensionOrderExists: 6,
    ReserveConcurrency: 7,
    UnReserveConcurrency: 8,
    CPOENotAllowed: 9,
    BillingError: 10,
}
const getChangeStatusResultEnum = () => ChangeStatusResultEnum;


const CancelClaimResult = {
    Success: 1,
    Failure: 2,
    VMFailure: 3
}
const getCancelClaimResult = () => CancelClaimResult;



export {
    getUploadExcelEnums, getPopupTypeEnums, getDiscountRuleSaveResult, getSaveDiscountRuleDetailsResult,
    getAssignDiscountRuleResult, getAddDiscountResultEnum, getProductClassification, getAddItemsOfServiceEnum,
    getWaseleResult, getEligibilityRequestPurpose, getCheckEligibilityResult, getGetInsuranceInfoResult, getVisitClaimNphiesStatus,
    getReloadStatementResult, getCancelRequestEnums, getSendStatementsToNphiesResult, getMarkStatementToCancelResult, getSendClaimResultEnum,
    getVisitClassificationEnum, getApprovalStatusEnum, getActionStatusEnum, getChangeStatusResultEnum, getServiceTypeEnum,
    getCancelClaimResult
}